





























































































import {
  BSidebar,
  BForm,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormInput,
  BPagination,
  BFormSelect,
  BFormDatepicker,
  BFormCheckboxGroup,
  BRow,
  BTable,
  BSpinner,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { BIAccesCreateModel } from "@/api/models/biAcces/biAcces";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { PaginatedList } from "@/api/models/common/paginatedList";
import { BIRapport } from "@/api/models/biRapport/biRapport";

@Component({
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BSidebar,
    BForm,
    BFormGroup,
    BFormCheckbox,
    BSpinner,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect,
    BFormCheckboxGroup
  },
  name: "create-bi-acces",
})
export default class CreateBiAcces extends Vue {
  @Prop({ required: true, type: Boolean })
  isAddNewBiAccesSidebarActive!: boolean;
  loading = false;

  required = required;

  newBIAcces: BIAccesCreateModel = {};
  powerBiRapports: BIRapport[] = [];


  async created() {
    await this.$http.myressif.biRapports
      .paginatedList()
      .then(
        (response: PaginatedList<BIRapport>) => (
          this.powerBiRapports = response.items
      ), 
      (error: any) => {
        if (
          error?.response?.data?.errors &&
          Object.keys(error.response.data.errors).length
        ) {
          errorAlert.fire({
            text: error.response.data.errors[
              Object.keys(error.response.data.errors)[0]
            ],
          });
        } else {
          errorAlert.fire({
            text: error?.response?.data?.detail ?? error.message,
          });
        }
      })
  }

  resetForm() {
    this.newBIAcces = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.biAcces
      .post(this.newBIAcces)
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Création d'un accès",
            text: "Accès créé avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-biAcces");
        this.$emit("update:is-add-new-bi-acces-sidebar-active", false);
        this.loading = false;
      });
  }
}
